export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/nav-d84b72aae065520cb215ebde0fd84c82.png";